import { render } from "./TopSubData.vue?vue&type=template&id=18e0a23a&scoped=true&ts=true"
import script from "./TopSubData.vue?vue&type=script&lang=ts"
export * from "./TopSubData.vue?vue&type=script&lang=ts"

import "./TopSubData.vue?vue&type=style&index=0&id=18e0a23a&scoped=true&lang=css"
import "./TopSubData.vue?vue&type=style&index=1&id=18e0a23a&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e0a23a"]])

export default __exports__